/** How long each test is. */
export const TEST_DURATION_SECONDS = 60 * 25; // 25 minutes
